import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "69",
  height: "71",
  viewBox: "0 0 69 71",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M33.7555 32.7759V0H36.7555V32.7759H69V35.7759H36.7555V71H33.7555V35.7759H0V32.7759H33.7555Z"
    }, null, -1)
  ]))]))
}
export default { render: render }